import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { StepState } from 'src/app/_shared/components/progress/models/progress-definitions';

@Component({
    selector: 'app-progress-step',
    templateUrl: './progress-step.component.html',
    styleUrls: ['./progress-step.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgressStepComponent {
    @Input() label: string = '';
    @Input() state: StepState = StepState.Pending;
    @Input() details: string | null = null;

    get statusClass(): string {
        switch (this.state) {
            case StepState.Completed:
                return 'gup-O-status -is-validated';
            case StepState.Running:
                return 'gup-O-status -is-waiting';
            case StepState.Error:
                return 'gup-O-status -is-refused';
            default:
                return 'gup-O-status -to-approve';
        }
    }
}
